export class TitleTextLink extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    /* Show the form if it's been posted */
    if (
      this.els?.['form-posted-indicator']?.exists &&
      this.els?.['form-container']?.exists
    ) {
      this.showForm()
    }
  }

  setupListeners () {
    super.setupListeners()

    if (
      this.els?.['form-trigger']?.exists &&
      this.els?.['form-container']?.exists
    ) {
      this.listeners.add(
        this.els['form-trigger'].element,
        'click',
        this.handleClick.bind(this),
      )
    }
  }

  handleClick (event) {
    event.preventDefault()
    this.showForm()
  }

  showForm () {
    this.els['form-trigger'].element.setAttribute('aria-hidden', 'true')
    this.els['form-container'].element.setAttribute('aria-hidden', 'false')
  }
}

if (!customElements.get('title-text-link')) {
  customElements.define('title-text-link', TitleTextLink, {
    extends: 'article',
  })
}
